import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./letter.css";

const DEFAULT_MSG = "Dear you,\n\nI wrote this letter just for you. Open the pages below and read it whenever you like.\n\nWith love";

const safePdf = (u) => {
  try {
    const url = new URL(u);
    if (url.protocol !== "https:") return "";
    const isDrive = url.hostname === "drive.google.com" || url.hostname === "docs.google.com";
    if (!isDrive && !/\.pdf$/i.test(url.pathname)) return "";
    if (url.hostname === "drive.google.com") return url.href.replace(/\/view(\?.*)?$/, "/preview");
    return `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url.href)}`;
  } catch { return ""; }
};

function Builder() {
  const [msg, setMsg] = useState("");
  const [pdf, setPdf] = useState("");
  const link = `${window.location.origin}/letter?${new URLSearchParams({ msg: msg || DEFAULT_MSG, pdf })}`;
  return (
    <div className="lt-card lt-builder" data-testid="letter-builder">
      <h2>Create a letter link</h2>
      <textarea rows={5} placeholder="Your personal message" value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="letter-msg-input" />
      <input placeholder="PDF link (https://…, e.g. Google Drive share link)" value={pdf} onChange={(e) => setPdf(e.target.value)} data-testid="letter-pdf-input" />
      {pdf && !safePdf(pdf) && <p className="lt-hint" data-testid="letter-pdf-error">Please paste a direct PDF link (ending in .pdf) or a Google Drive link — not a WhatsApp link.</p>}
      <a className="lt-btn" href={pdf && !safePdf(pdf) ? undefined : link} data-testid="letter-preview-link">Open my letter</a>
    </div>
  );
}

export default function Letter() {
  const [params] = useSearchParams();
  const [open, setOpen] = useState(false);
  const pdf = safePdf(params.get("pdf") || "");
  const msg = params.get("msg") || DEFAULT_MSG;
  if (!params.get("pdf") && !params.get("msg")) return <div className="lt-page"><Builder /></div>;
  const share = `https://wa.me/?text=${encodeURIComponent(`You have a special letter 💌 ${window.location.href}`)}`;

  return (
    <div className="lt-page">
      <h1 className={`lt-title ${open ? "lt-hide" : ""}`}>You Have a Special Letter 💌</h1>
      <button className={`lt-envelope ${open ? "is-open" : ""}`} onClick={() => setOpen(true)} aria-label="Open letter" data-testid="letter-envelope">
        <span className="lt-back" />
        <span className="lt-paper" />
        <span className="lt-front" />
        <span className="lt-flap" />
        <span className="lt-seal">❤</span>
      </button>
      {!open && <p className="lt-hint">Tap the envelope to open</p>}
      {open && (
        <div className="lt-card lt-reveal" data-testid="letter-content">
          <p className="lt-msg" data-testid="letter-message">{msg}</p>
          {pdf ? <iframe className="lt-pdf" src={pdf} title="Letter PDF" data-testid="letter-pdf" />
               : params.get("pdf") && <p className="lt-hint" data-testid="letter-pdf-invalid">This letter's PDF link isn't a valid PDF or Google Drive link.</p>}
          {pdf && <a className="lt-link" href={pdf} target="_blank" rel="noreferrer">Open PDF in full screen</a>}
          <a className="lt-btn lt-wa" href={share} target="_blank" rel="noreferrer" data-testid="letter-whatsapp-btn">Share on WhatsApp</a>
        </div>
      )}
    </div>
  );
}
